export default __webpack_public_path__ + "static/media/KnowledgeBase.e934f3fd.png";